import { OPEN_STATUSES } from "../../data/company";
import { activeListingCount, availableToday, listingLimit } from "../../lib/company";
import { useCompany } from "../../lib/companyContext";
import KpiCard from "../../components/company/KpiCard";
import BookingQueue from "../../components/company/BookingQueue";
import QuickActions from "../../components/company/QuickActions";
import UpcomingMovements from "../../components/company/UpcomingMovements";
import { PageTitle } from "../../components/company/ui";
import { useT } from "../../i18n";

export default function CompanyOverview() {
  const t = useT();
  const k = t.company.overview.kpis;
  const { state } = useCompany();
  // null = unlimited (free launch without a cap), 0 = no plan
  const limit = listingLimit(state);
  const usage = activeListingCount(state);

  const queue = state.bookings
    .filter((b) => OPEN_STATUSES.includes(b.status))
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt))
    .slice(0, 6);

  return (
    <>
      <PageTitle className="mb-5">{t.company.overview.title}</PageTitle>

      <div className="grid grid-cols-[repeat(auto-fit,minmax(170px,1fr))] gap-3">
        <KpiCard label={k.activeListings} value={usage} href="/company/listings" />
        <KpiCard label={k.available} value={availableToday(state)} href="/company/calendar" />
        <KpiCard
          label={k.activeRentals}
          value={state.bookings.filter((b) => b.status === "active").length}
          href="/company/bookings?tab=active"
        />
        <KpiCard
          label={k.newRequests}
          value={state.bookings.filter((b) => b.status === "pending").length}
          href="/company/bookings"
        />
        <KpiCard
          label={k.listingLimit}
          // Unlimited: just the count, with "No limit" underneath (a phrase as the big value wrapped on phones)
          value={limit === null ? usage : limit ? `${usage} / ${limit}` : "—"}
          note={limit === null ? k.noLimit : undefined}
          href="/company/subscription"
          meter={limit ? (usage / limit) * 100 : undefined}
          meterAlert={!!limit && usage >= limit}
        />
      </div>

      <div className="mt-4 grid items-start gap-4 lg:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)]">
        <BookingQueue bookings={queue} />
        <div className="grid gap-4">
          <QuickActions />
          <UpcomingMovements />
        </div>
      </div>
    </>
  );
}
